import { Input, Select } from 'antd'
import { getAddressFromPin } from 'pages/profile/postalApi';
import React, { useEffect, useState } from 'react'
import axios from 'axios';

const UserCurrentAddressV3 = ({ permanentAddress, setPermanentAddress, currentAddress, setCurrentAddress, current }) => {


    const chevron = require('../../Assets/userManagementV3/chevron.png').default
    const [autoFillPin, setAutoFillPin] = useState(false);
    const [autoFillPin1, setAutoFillPin1] = useState(false);
    const [countries, setCountries] = useState([]);
    const [countries1, setCountries1] = useState([]);

    useEffect(() => {
        if (autoFillPin) {
            getAddressFromPin(currentAddress.pincode, (city, state, country) => {
                setCurrentAddress(prevAutoAddress => ({
                    ...prevAutoAddress,
                    city,
                    state,
                    country,

                }));
            });
        }
    }, [autoFillPin, currentAddress?.pincode])

    useEffect(() => {
        if (autoFillPin1) {
            getAddressFromPin(permanentAddress.pincode, (city, state, country) => {
                setPermanentAddress(prevAutoAddress => ({
                    ...prevAutoAddress,
                    city,
                    state,
                    country,

                }));
            });
        }
    }, [autoFillPin1, permanentAddress?.pincode])

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get('https://restcountries.com/v3.1/all');
                const countryNames = response.data.map(country => country.name.common);
                if (current) {
                    setCountries(countryNames.sort());
                } else {
                    setCountries1(countryNames.sort());
                }
            } catch (error) {
                console.error('Error fetching countries:', error);
            }
        };

        fetchCountries();
    }, []);


    const handlePincodeChange = (numericValue) => {
        if (current) {
            setCurrentAddress(prevAddress => ({
                ...prevAddress,
                pincode: numericValue
            }));
            setAutoFillPin(true)
        } else {
            setPermanentAddress(prevAddress => ({
                ...prevAddress,
                pincode: numericValue
            }));
            setAutoFillPin1(true)
        }

    }

    const handleCountryChange = (value) => {
        if (current) {
            setCurrentAddress(prevAddress => ({
                ...prevAddress,
                country: value
            }));
        } else {
            setPermanentAddress(prevAddress => ({
                ...prevAddress,
                country: value
            }));
        }
    }

    const handleAddressChange = (e) => {
        if (current) {
            setCurrentAddress(prevAddress => ({
                ...prevAddress,
                h_no: e.target.value
            }));
        } else {
            setPermanentAddress(prevAddress => ({
                ...prevAddress,
                h_no: e.target.value
            }));
        }
    }

    const handleCityChange = (e) => {
        if (current) {
            setCurrentAddress(prevAddress => ({
                ...prevAddress,
                city: e.target.value
            }));
        } else {
            setPermanentAddress(prevAddress => ({
                ...prevAddress,
                city: e.target.value
            }));
        }
    }

    const handleStateChange = (e) => {
        if (current) {
            setCurrentAddress(prevAddress => ({
                ...prevAddress,
                state: e.target.value
            }));
        } else {
            setPermanentAddress(prevAddress => ({
                ...prevAddress,
                state: e.target.value
            }));
        }
    }

    return (
        <div style={{ width: '100%', height: '100%', padding: current ? '20px 24px 0px 24px' : '30px 24px 0px 24px' }}>
            <div style={{ color: '#AEAEAE', fontSize: 18, fontWeight: 400, marginBottom: 16 }}>{current ? 'Current address' : 'Permanent address'}</div>

            <div style={{ display: 'flex', flexWrap: "wrap", justifyContent: 'space-between', width: '100%' }}>
                <div style={{ width: '30%', }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12, }}>House No./Locality/Area</label>
                    <Input
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6', padding: '0px 0px 5px 0px' }}
                        bordered={null}
                        inputId={"-998"}
                        value={current ? currentAddress?.h_no : permanentAddress?.h_no}
                        onChange={(e) => handleAddressChange(e)}

                    />
                </div>
                <div style={{ width: '30%', }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12, }}>Pincode</label>
                    <Input
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6', padding: '0px 0px 5px 0px' }}
                        inputId={"-998"}
                        bordered={null}
                        value={current ? currentAddress?.pincode : permanentAddress?.pincode}
                        onChange={(e) => {
                            const numericValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 6);
                            handlePincodeChange(numericValue)
                        }}
                    />
                </div>
                <div style={{ width: '30%', }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12, }}>District</label>
                    <Input
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6', padding: '0px 0px 5px 0px' }}
                        bordered={null}
                        inputId={"-998"}
                        value={current ? currentAddress?.city : permanentAddress?.city}
                        onChange={(e) => handleCityChange(e)}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', flexWrap: "wrap", justifyContent: 'space-between', width: '65%', marginTop: '2%' }}>
                <div style={{ width: '46%', }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12, }}>State</label>
                    <Input
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6', padding: '0px 0px 5px 0px' }}
                        bordered={null}
                        inputId={"-998"}
                        value={current ? currentAddress?.state : permanentAddress?.state}
                        onChange={(e) => handleStateChange(e)}
                    />
                </div>
                <div style={{ width: '46%' }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12, }}>Country</label>
                    <Input
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6', padding: '0px 0px 5px 0px' }}
                        bordered={null}
                        inputId={"-998"}
                        value={current ? currentAddress?.country : permanentAddress?.country}
                        onChange={(e) => handleCountryChange(e.target.value)}
                    />
                </div>

            </div>

        </div>
    )
}

export default UserCurrentAddressV3